"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetch = void 0;
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const snackbar_context_1 = require("../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../composite/snackbar/snackbar-types");
const abortable_fetch_1 = require("./abortable-fetch");
const event_callback_hook_1 = require("./event-callback-hook");
const react_intl_1 = require("react-intl");
const error_utils_1 = require("./error-utils");
const local_storage_hook_1 = require("./local-storage-hook");
function useFetch(request, opts) {
    const [result, setResult] = react_1.useState();
    const [loading, setLoading] = react_1.useState(false);
    const [counter, setCounter] = react_1.useState(0);
    const key = JSON.stringify({ request, opts, counter });
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const intl = react_intl_1.useIntl();
    const [cachedData, setCachedData] = local_storage_hook_1.useLocalStorage(key, null);
    react_1.useEffect(() => {
        let fetch;
        async function load() {
            if (opts === null || opts === void 0 ? void 0 : opts.skip) {
                setResult(undefined);
                return;
            }
            try {
                setLoading(true);
                if ((opts === null || opts === void 0 ? void 0 : opts.cacheResponse) && cachedData) {
                    react_dom_1.unstable_batchedUpdates(() => {
                        setResult(cachedData);
                        setLoading(false);
                    });
                    return;
                }
                fetch = abortable_fetch_1.abortableFetch(request, opts);
                const data = await (opts && opts.textResponse
                    ? fetch.text()
                    : fetch.json());
                react_dom_1.unstable_batchedUpdates(() => {
                    setResult(data);
                    if (opts === null || opts === void 0 ? void 0 : opts.cacheResponse) {
                        setCachedData(data);
                    }
                    setLoading(false);
                });
            }
            catch (err) {
                if (err.name !== 'AbortError') {
                    setLoading(false);
                    const errorDetail = error_utils_1.getErrorMessage(err);
                    const message = intl.formatMessage({
                        id: 'EAS_FETCH_MSG_ERROR',
                        defaultMessage: 'Chyba načtení dat: {detail}',
                    }, { detail: errorDetail });
                    showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                    throw err;
                }
            }
        }
        load();
        return () => {
            if (fetch != null) {
                fetch.abort();
            }
        };
        // run effect only if input params change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
    const reset = event_callback_hook_1.useEventCallback(() => {
        setCounter((counter) => ++counter);
    });
    return [result, loading, reset, setLoading];
}
exports.useFetch = useFetch;
//# sourceMappingURL=fetch-hook.js.map